import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner/LoadingSpinner';
import { ROUTES } from '../../config/constants';

const PublicRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();

    if (loading) {
        return <LoadingSpinner fullScreen />;
    }

    return !isAuthenticated ? children : <Navigate to={ROUTES.DASHBOARD} />;
};

export default PublicRoute;